import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installScrollbar } from "@lumora/ui";
import { App } from "./App.js";
import "@lumora/ui/live-panel.css";
import "@lumora/ui/mfa.css";
import "@lumora/ui/dev-claim.css";
import "@lumora/ui/floating-phone.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

installScrollbar();
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
